'use client'

import { Backdrop } from '@mui/material';
import { FC } from 'react';
import { COLORS } from '@/constants';

import dynamic from "next/dynamic";

export const Circular = dynamic(
  () => import("@mui/material/CircularProgress"),
  { ssr: false }
);

type FullscreenLoaderProps = {
  open: boolean;
}

export const FullscreenLoader: FC<FullscreenLoaderProps> = ({ open }) => (
  <Backdrop
    open={open}
    style={{ zIndex: 9999, background: COLORS.white }}
    transitionDuration={300}
  >
    <Circular size={40} sx={{ color: COLORS.orange }} />
  </Backdrop>
);
